import { absolutePath } from "../../absolutePath";

export const accessGroupSources = {
  manage: () => absolutePath("admin/access_group_sources/manage"),
  index: (params = {}) => absolutePath("admin/access_group_sources", params),
};
